<div class="ticket-select-sector-wrapper">
  <div class="heading-5 text-grey medium" *ngIf="clientNotificationEmail">
    {{ 'general.api_cart_client_notification_email' | translate }}: {{clientNotificationEmail}}
  </div>
  <div class="flex flex-column decreased-margin" *ngIf="selectedView === viewType.VIEW_SECTORS">
    <button mat-button class="input-button sector-button" *ngFor="let enabledSector of enabledSectors" [ngClass]="{'active': enabledSector.id === selectedSector?.id}"
            (click)="selectSectorById.emit(enabledSector.id)" (mouseenter)="hoverOnActiveSector.emit(enabledSector.id)" (mouseleave)="hoverOnActiveSector.emit()">
      <div class="flex space-between">
        <div class="align-left">
          <span class="heading-5 no-margin">{{ enabledSector.name | translate }}</span>
          <div class="flex body-3 text-base bold">
            <div>
              <span class="text-muted medium">{{'general.api_general_tickets' | translate}}:&nbsp;</span>
              <span>{{ eventService.getFreePlacesString(enabledSector.freePlaces) | quantityInPcs }}</span>
            </div>
            <div>
              <span class="text-muted medium">{{'general.api_cart_table_price' | translate}}:&nbsp;</span>
              <span>{{enabledSector.minPrice !== enabledSector.maxPrice ? ((enabledSector.minPrice | price:true) + ' - ') : ''}}{{enabledSector.maxPrice | price}}</span>
            </div>
          </div>
        </div>
        <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
      </div>
    </button>
    <button mat-flat-button color="primary" class="top-spacer"
            *ngIf="!routeService.isWindow && hasVenueMap && selectedSector"
            (click)="backToSectorSelection.emit()">
      {{ 'general.api_sales_back_to_venue' | translate }}
    </button>
    <div class="body-2 text-muted" *ngIf="!enabledSectors.length">
      <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
      {{ 'general.api_sales_no_available_sectors' | translate }}
    </div>
  </div>
  <div class="flex flex-column" *ngIf="selectedView === viewType.VIEW_TICKETS">
    <ng-container *ngIf="selectedSector">
      <div class="flex flex-center">
        <button mat-button class="icon-button small" (click)="backToSectorSelection.emit()" *ngIf="enabledSectors.length > 1">
          <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
        </button>
        <div class="heading-5 no-margin">{{ selectedSector.name | translate }}</div>
      </div>
      <table class="ticket-select-table" *ngFor="let priceClass of selectedSector.priceClasses">
        <tr class="price-type-default price-header-row">
          <td *ngIf="priceClass.hasSeats">&nbsp;</td>
          <td *ngIf="getPriceClassOtherOptions(priceClass).length"></td>
          <td class="max-width body-3 text-grey">{{priceClass.countString | quantityInPcs}}</td>
          <td class="price-type-price">
            <ng-container *ngIf="!priceClass.hasSeats">{{ getPriceClassDefaultOption(priceClass)?.price | price }}</ng-container>
          </td>
        </tr>
        <tr class="price-type-default">
          <td *ngIf="priceClass.hasSeats">
            <mat-icon [ngStyle]="{color: priceClass.color}" class="prize-zone-icon svg-icon" [svgIcon]="'circle_filled'"></mat-icon>
          </td>
          <td *ngIf="getPriceClassOtherOptions(priceClass).length">
            <button mat-button class="icon-button input-button small" (click)="togglePriceClassById(priceClass.id)">
              <mat-icon class="svg-icon" [svgIcon]="selectedPriceClassIds.includes(priceClass.id) ? 'arrow_down' : 'arrow_right'"></mat-icon>
            </button>
          </td>
          <td class="price-type-name">{{ getPriceClassDefaultOption(priceClass)?.name | translate }}</td>
          <td *ngIf="priceClass.hasSeats" class="price-type-price">
            {{ getPriceClassDefaultOption(priceClass)?.price | price }}
          </td>
          <td *ngIf="!priceClass.hasSeats">
            <app-add-remove [count]="suggestedTicketsCountByClassType(priceClass.id, getPriceClassDefaultOption(priceClass)?.id)"
                            [max]="getPriceClassMaxTickets(priceClass)"
                            [withHints]="cartService.isSelfService"
                            (countChange)="changeTicketCount(priceClass, getPriceClassDefaultOption(priceClass)?.id, 'update', $event)"
                            (add)="changeTicketCount(priceClass, getPriceClassDefaultOption(priceClass)?.id, 'add')"
                            (remove)="changeTicketCount(priceClass, getPriceClassDefaultOption(priceClass)?.id, 'reduce')"></app-add-remove>
          </td>
        </tr>
        <ng-container *ngIf="selectedPriceClassIds.includes(priceClass.id) && getPriceClassOtherOptions(priceClass).length">
          <ng-container *ngFor="let option of getPriceClassOtherOptions(priceClass); let firstOption = first; let lastOption = last">
            <tr class="price-header-row" *ngIf="!priceClass.hasSeats">
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td class="price-type-price">{{ option.price | price }}</td>
            </tr>
            <tr>
              <td *ngIf="priceClass.hasSeats">&nbsp;</td>
              <td>&nbsp;</td>
              <td class="price-type-name">{{ option.name | translate }}</td>
              <td class="align-right" [ngClass]="{'price-type-price': priceClass.hasSeats}">
                <ng-container *ngIf="priceClass.hasSeats">{{ option.price | price }}</ng-container>
                <app-add-remove *ngIf="!priceClass.hasSeats"
                                [count]="suggestedTicketsCountByClassType(priceClass.id, option.id)"
                                [max]="getPriceClassMaxTickets(priceClass)"
                                [withHints]="cartService.isSelfService"
                                (countChange)="changeTicketCount(priceClass, option.id, 'update', $event)"
                                (add)="changeTicketCount(priceClass, option.id, 'add')"
                                (remove)="changeTicketCount(priceClass, option.id, 'reduce')"></app-add-remove>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
      <div class="add-to-cart-button" *ngIf="!routeService.isWindow && selectedSector.priceClasses?.length && suggestEnabled">
        <button mat-flat-button color="primary" [disabled]="!suggestedTicketsCount || limitExceeded" (click)="suggest()">{{ 'general.api_cart_add' | translate }}</button>
      </div>
      <div class="body-2 text-muted" *ngIf="!selectedSector.priceClasses?.length">
        <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
        {{ 'general.api_sales_no_tickets' | translate }}
      </div>
    </ng-container>
  </div>
</div>
